require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./videos-we-are-cloudthing.json") })
        }
      }, "path---videos-we-are-cloudthing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---videos-we-are-cloudthing!./.cache/json/videos-we-are-cloudthing.json
// module id = 957
// module chunks = 231608221292675